import React, { useState, useEffect, Component } from 'react';
import { ClipLoader } from 'react-spinners';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import LeaseApiService from '../../services/apiService';
import Select from "react-select";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { toast } from 'react-toastify';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const PM_AGREEMENT_REPORT_URL = "https://reports.apps.rabahrain.com/RDLReport/WebForm/frmPMAgreement_Print.aspx"


// _username, _password, _db, _baseDb as received in the launch URL (saved by the header on entry)
const getPMReportAuth = () => {
    try {
        const [_username, _password, _db, _baseDb] = JSON.parse(atob(localStorage.getItem("_rep")));
        return { _username, _password, _db, _baseDb };
    } catch (e) {
        return null;
    }
}

const LeaseRePrint = () => {
    const apiService = new LeaseApiService();
    const [permissions, setPermissions] = useState([])
    const [FilterTab, setFilterTab] = useState(true);
    const [reportType, setReportType] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [reservationList, setReservationList] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [pmPropertyList, setPmPropertyList] = useState([]);
    const [pmLeaseList, setPmLeaseList] = useState([]);
    const [pmLeaseAll, setPmLeaseAll] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        fetchDropdownData()
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Reservation Approval");
        setPermissions(permissions[0]);
    }, [])
    const [formData, setFormData] = useState({
        reportType: [],
        Property: [],
        unit: [],
        reservationNo: [],
        agreementType: false,
    });

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRPReportTypes,LRPPropertyNos,LRPLeaseNos');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setReportType(res?.data?.dropdowns?.LRPReportTypes)
            setPropertyList(res?.data?.dropdowns?.LRPPropertyNos)
            setReservationList(res?.data?.dropdowns?.LeaseNo)
            setLeaseList(res?.data?.dropdowns?.LeaseNo)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }

    const handleClearFilters = () => {
        setFormData({
            reportType: [],
            Property: [],
            unit: [],
            reservationNo: [],
            agreementType: false,
        });
    }
    const isPMContract = formData?.reportType?.label === "Property Management Contract";

    const loadPMContractDropdowns = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRPGetPropertyForPMContractType,LRPGetLeaseNoForPMContractType');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPmPropertyList(res?.data?.dropdowns?.LRPGetPropertyForPMContractType || [])
            setPmLeaseList(res?.data?.dropdowns?.LRPGetLeaseNoForPMContractType || [])
            setPmLeaseAll(res?.data?.dropdowns?.LRPGetLeaseNoForPMContractType || [])
        } catch (error) {
            console.error('Error fetching PM contract dropdown data:', error);
        }
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (!value && name === "Property") {
            setFormData(prev => ({ ...prev, Property: null, unit: null, reservationNo: null }));
            setUnitList([])
            setReservationList(leaseList)
            setPmLeaseList(pmLeaseAll)
        } else if (!value && name === "unit") {
            setFormData(prev => ({ ...prev, unit: null, reservationNo: null }));
            setReservationList(leaseList)
            setPmLeaseList(pmLeaseAll)
        } else if (name === "reportType" && value?.label === "Property Management Contract") {
            setFormData({ reportType: value, Property: null, unit: null, reservationNo: null, agreementType: false });
            setUnitList([])
            setPmPropertyList([])
            setPmLeaseList([])
            setPmLeaseAll([])
            await loadPMContractDropdowns()
        } else if (name === "Property" && isPMContract) {
            setFormData(prev => ({ ...prev, Property: value, unit: null, reservationNo: null }));
            setUnitList([])
            setPmLeaseList(pmLeaseAll)
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRPGetUnitsForPMContractType');
            params.append('CascadValue', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || [])
        } else if (name === "Property") {
            setFormData(prev => ({ ...prev, unit: null, Property: value, reservationNo: null }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRPGetUnitsForCheckout');
            params.append('CascadValue', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setReservationList(leaseList)
            setUnitList(res?.data?.items)
        } else if (name === "unit" && isPMContract) {
            setFormData(prev => ({ ...prev, unit: value, reservationNo: null }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRPGetLeaseForPMContractType');
            params.append('CascadValue', formData?.Property?.value?.value);
            params.append('CascadText', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            if (res?.data?.items?.length) {
                setPmLeaseList(res.data.items)
                let lease = res.data.items[0]
                setFormData(prev => ({ ...prev, reservationNo: { label: lease?.text, value: lease } }));
            } else {
                setPmLeaseList(pmLeaseAll)
            }
        } else if (name === "unit") {
            setFormData(prev => ({ ...prev, unit: value }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRPGetLeaseNosForCheckout');
            params.append('CascadValue', formData?.Property?.value?.value);
            params.append('CascadText', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            if (res?.data?.items) {
                setReservationList(res?.data?.items)
                let lease = res?.data?.items[0]
                setFormData(prev => ({ ...prev, reservationNo: { label: lease?.text, value: lease } }));
            } else {
                setReservationList(leaseList)
            }
        } else {
            if (name === "reportType" && isPMContract) {
                setUnitList([])
                setReservationList(leaseList)
                setPmLeaseList(pmLeaseAll)
                setFormData(prev => ({ ...prev, reportType: value, Property: null, unit: null, reservationNo: null }));
                return
            }
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handlePrint = () => {
        if (!formData?.reportType?.label) {
            toast.warn("Select Report Type")
            return
        } else if (formData?.reportType?.label === "Lease Checkout" && !formData?.reservationNo?.label) {
            toast.warning("Select Lease No")
            return
        } else if (isPMContract) {
            if (!formData?.reservationNo?.label) {
                toast.warning("Select Lease No")
                return
            }
            const auth = getPMReportAuth();
            if (!auth) {
                toast.warning("Session details missing, please re-open the module from the home page")
                return
            }
            const query = new URLSearchParams({ ...auth, leaseNo: formData?.reservationNo?.label });
            window.open(`${PM_AGREEMENT_REPORT_URL}?${query.toString()}`, "_blank");
            return
        }
        if (formData?.reportType?.label) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "LeaseNo", value: formData?.reservationNo?.label },
                    { name: "reportName", value: "LSEREGCHECKOUT" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    return (
        <div className='p-3'>
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div
                        className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
                            }`}
                    >
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Report Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.reportType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'reportType', value: selectedOption })}
                                    options={reportType?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div></div>
                            <div></div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.Property}
                                    isClearable
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'Property', value: selectedOption })}
                                    options={(isPMContract ? pmPropertyList : propertyList)?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unit}
                                    isClearable
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unit', value: selectedOption })}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div></div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease No</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.reservationNo}
                                    isClearable
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'reservationNo', value: selectedOption })}
                                    options={(isPMContract ? pmLeaseList : reservationList)?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-3">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="agreementType"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.agreementType}
                                        onChange={(e) => setFormData(prev => ({ ...prev, agreementType: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="agreementType">
                                        Agreement Type 1
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex gap-1">
                                {loading === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => handlePrint()} className="mainbtnGry flex-end gap-2 w-50">
                                        <FaFileCircleExclamation color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Print</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50" >
                                    <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    )
}
export default LeaseRePrint;
